import React, { useEffect, useRef, useState } from 'react'
import { FileUpload, FileUploadHandlerParam } from 'primereact/fileupload'
import { PropsType } from '../../models/util'
import LuxButton from '../buttons/Button'
import useImage from 'use-image'

interface FileInputProps extends PropsType {
    showProgressBar?: boolean
    maxFileSize?: number
    uploadHandler?: (e: FileUploadHandlerParam) => void
    disabled?: boolean
    name: string
    accept?: string
    chooseOptions?: any
    uploadOptions?: any
    cancelOptions?: any
    multiple?: boolean
    clear?: boolean
    value?: any
    label?: string
    uploadLabel?: string
    onClear?: () => void
    onRemove?: (file?: File) => void
    onChangeCallback: (e: any) => void
    mandatory?: boolean
    emptyMessage?: string
}

export default (props: FileInputProps) => {
    const {
        // showProgressBar,
        maxFileSize,
        uploadHandler,
        disabled,
        name,
        accept,
        chooseOptions,
        cancelOptions,
        uploadOptions,
        multiple,
        clear,
        value,
        label,
        uploadLabel,
        mandatory,
        emptyMessage,
        onClear,
        onRemove,
        onChangeCallback,
    } = props

    const [totalSize, setTotalSize] = useState(0)
    const [_accept, _setAccept] = useState('*')
    const [thumb, setThumb] = useState()
    const [image, status] = useImage(thumb, 'anonymous')

    const fileUploadRef = useRef(null)

    useEffect(() => {
        if (accept) {
            _setAccept(accept)
        }
    }, [accept])

    useEffect(() => {
        if (clear) {
            if (fileUploadRef) {
                fileUploadRef.current.clear()
            }
        }
    }, [clear])

    useEffect(() => {
        if (value && value !== '' && value.length > 0) {
            setThumb(value)
        }
    }, [value])

    const isImage = (url: string): string => {
        const imageRegex =
            /(?:https?|ftp):\/\/[\S]*\.(?:png|jpe?g|gif|svg|webp)(?:\?\S+=\S*(?:&\S+=\S*)*)?/g

        if (imageRegex.test(url)) {
            return 'image/*'
        }

        return '*'
    }

    const makeDownloadable = (url: any, children: any) => {
        return url ? (
            <a target="_blank" href={url}>
                {children}
            </a>
        ) : (
            children
        )
    }

    const onTemplateSelectUpload = (e: any) => {
        let _totalSize = totalSize
        let files = e.files
        for (let i = 0; i < files.length; i++) {
            let file = files[i]
            _totalSize += file.size || 0
        }
        setTotalSize(_totalSize)
    }

    const onTemplateRemove = (file?: any, callback?: any) => {
        let _totalSize = totalSize
        if (onRemove) {
            onRemove(file)
        }
        if (file) {
            if (onClear && totalSize - file.size === 0) {
                onClear()
            }
            _totalSize = _totalSize - file.size
        }
        if (callback) {
            callback()
        }
        setTotalSize(_totalSize)
    }

    const onTemplateClear = () => {
        if (onClear) {
            onClear()
        }
        setTotalSize(0)
    }

    const itemTemplate = (file: any, props?: any) => {
        if (!multiple && file.name !== value?.name) {
            return
        }
        return (
            file && (
                <div
                    className="p-d-flex p-ai-center p-flex-wrap justify-content-between mt-4 mb-2"
                    style={{ width: '100%' }}>
                    <div className="p-d-flex p-ai-center">
                        {file?.type.includes('image') &&
                            makeDownloadable(
                                file.objectURL,
                                <img
                                    width={100}
                                    alt={file.name}
                                    role="presentation"
                                    src={file.objectURL}
                                />
                            )}
                        {!file?.type.includes('image') && (
                            <i
                                className="pi pi-file"
                                style={{ fontSize: '1.5rem' }}></i>
                        )}
                        {makeDownloadable(
                            file.objectURL,
                            <span className="p-d-flex p-dir-col p-text-left p-ml-3">
                                {file.name}
                                {!file.uploaded && (
                                    <small>
                                        {new Date().toLocaleDateString()}
                                    </small>
                                )}
                            </span>
                        )}
                    </div>
                    {!file.uploaded && (
                        <LuxButton
                            icon="pi pi-times"
                            classes="p-button-outlined p-button-rounded p-button-danger p-ml-auto"
                            style={{ maxWidth: '2.357rem' }}
                            tooltip="Remove"
                            tooltipPosition="bottom"
                            onClick={() =>
                                onTemplateRemove(file, props.onRemove)
                            }
                        />
                    )}
                </div>
            )
        )
    }

    const emptyTemplate = () => {
        return (
            <div className="p-d-flex p-ai-center p-dir-col" onClick={() => {}}>
                <i
                    className="pi pi-image p-mt-3 p-p-5"
                    style={{
                        fontSize: '5em',
                        borderRadius: '50%',
                        backgroundColor: 'var(--surface-b)',
                        color: 'var(--surface-d)',
                    }}></i>
                <span
                    style={{
                        fontSize: '1.2em',
                        color: 'var(--text-color-secondary)',
                    }}
                    className="p-my-5">
                    {emptyMessage ? emptyMessage : 'Drag and Drop a file here'}{' '}
                </span>
            </div>
        )
    }

    return (
        <div className="col-12 floating-label" style={{ marginTop: '2rem' }}>
            {label && (
                <label
                    className={`active`}
                    style={{
                        padding: '1rem 0',
                        transform: 'translate(0, -35px) scale(0.75)',
                    }}>
                    {`${label}${mandatory ? ' *' : ''}`}
                </label>
            )}
            {/* value &&
                value !== '' &&
                itemTemplate({
                    objectURL: value,
                    name: '1 file Uploaded ',
                    type: isImage(value),
                    uploaded: true,
                })*/}
            <FileUpload
                onSelect={(e: any) => {
                    // console.log('SELECT FILE INPUT', e)
                    let files: any[] = Array.from(e.files)
                    onChangeCallback({ value: multiple ? files : files[0] })
                    onTemplateSelectUpload(e)
                }}
                onUpload={onTemplateSelectUpload}
                onClear={onTemplateClear}
                onError={onTemplateClear}
                onRemove={onTemplateRemove}
                multiple={multiple}
                ref={fileUploadRef}
                name={name}
                disabled={disabled}
                uploadOptions={uploadOptions}
                chooseOptions={chooseOptions}
                cancelOptions={cancelOptions}
                customUpload
                uploadHandler={uploadHandler}
                accept={_accept}
                maxFileSize={maxFileSize}
                itemTemplate={itemTemplate}
                emptyTemplate={emptyTemplate}
            />
        </div>
    )
}
